export default "__VITE_ASSET__BxcPm7zO__"